module.exports = __webpack_public_path__ + "static/media/thumbnail.81bcb4c9.jpg";